'use client'

import React from 'react'
import { ActionButton } from '@/types/company'
import { sendKarteEvent } from '@/utility/karte'
import styles from './styles.module.scss'

interface ActionButtonCompanyProps {
  actionButtons?: ActionButton[]
  companyId: number
  companyName?: string
  articleTitle?: string
}

export default function ActionButtonCompany({
  actionButtons = [],
  companyId,
  companyName,
  articleTitle,
}: ActionButtonCompanyProps) {
  if (!actionButtons.length) return null

  const handleButtonClick = (button: ActionButton, index: number) => {
    // KARTE イベントを送信
    const trackingData = {
      title: articleTitle || document.title,
      name: button.text || button.name,
      url: window.location.href,
      link: button.url,
      companyName: companyName,
    }

    sendKarteEvent('click_item_detail', trackingData)

    window.open(button.url, '_blank')
  }

  return (
    <div className={styles.actionContainer}>
      <div className={styles.actionContents}>
        <ul className={styles.actionList}>
          {actionButtons.map((actionBtn, i) => (
            <li key={actionBtn.id} className={styles.actionItem}>
              <a
                href={actionBtn.url}
                target='_blank'
                rel='noopener noreferrer'
                className={styles.actionButton}
                onClick={(e) => {
                  e.preventDefault()
                  handleButtonClick(actionBtn, i)
                }}
              >
                {actionBtn.text || actionBtn.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
